export var clinical = {
    900: '#336D15',
    800: '#578F27',
    700: '#6BA330',
    600: '#80B73A',
    500: '#8FC742',
    400: '#A0D05F',
    300: '#B2D87D',
    200: '#C8E3A3',
    100: '#DEEEC7',
    50: '#F2F9E8',
};
//# sourceMappingURL=clinical.js.map